import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Datepicker from "vuejs-datepicker";
import PostedOffers from "@/views/PostedOffers/PostedOffers";
import moment from 'moment';
export default {
    props: ['leadsIdEdit'],
    components: {
        VuePerfectScrollbar,
        Datepicker,
        PostedOffers
    },
    data: function () {
        return {
            show: false,
            test: true,
            states: ['NY', 'Toronto'],
            state: null,
            initial: null,
            first_name: '',
            last_name: '',
            insurance: '',
            body_parts: '',
            address: '',
            suite: '',
            city: '',
            zip_code: '',
            region: '',
            home_tel: '',
            mobile_tel: '',
            call_notification: false,
            text_notification: false,
            note: '',
            treatment: '',
            date: '',
            asap: false,
            therapist: [],
            selectRegions: [],
            openTherapist: false,
            openRegion: false,
            offer_in: false,
            full_time_in: false,
            part_time2_in: false,
            part_time1_in: false,
            offer_out: false,
            full_time_out: false,
            part_time2_out: false,
            part_time1_out: false,
            assigned_therapists: {
                id: null,
                show_in_region_full_time: true,
                show_in_region_part_time_one: null,
                show_in_region_part_time_two: null,
                // show_out_region_full_time: true,
                // show_out_region_part_time_one: null,
                // show_out_region_part_time_two: null,
                therapists: {
                    full_time: [],
                    part_time2: [
                        {
                            id: 4,
                            first_name: "Marvin",
                            last_name: "Serrano",
                            ft_pt: "Part-Time2",
                            assigned: true
                        }],
                    part_time1: [
                        {
                            id: 36,
                            first_name: "Alex",
                            last_name: "Lui",
                            ft_pt: "Part-Time1",
                            assigned: true
                        }]
                },
                regions: [
                    {
                        id: 2752,
                        name: "South Bay",
                        assigned: true
                    },
                    {
                        id: 2753,
                        name: "West Los Angeles",
                        assigned: false
                    },
                    {
                        id: 2754,
                        name: "San Gabriel Valley",
                        assigned: false
                    },
                    {
                        id: 2755,
                        name: "Orange County",
                        assigned: false
                    },
                    {
                        id: 2756,
                        name: "Hollywood/Mid City",
                        assigned: false
                    },
                ]
            },
            filtered_therapists: {
                therapists: {
                    full_time: [],
                    part_time2: [],
                    part_time1: []
                },
            },
            show_in_region_full_time: false,
            show_in_region_part_time_one: false,
            show_in_region_part_time_two: false,
        }
    },
    computed: {
        assignedRegions: function () {
            return this.assigned_therapists.regions.filter((e) => e.assigned);
        },
        assignedTherapist: function () {
            const therapist = [];
            for (let type in this.assigned_therapists.therapists) {
                this.assigned_therapists.therapists[type].forEach((e) => {if(e.assigned) therapist.push(e)});
            }
            return therapist;
        }
    },

    methods: {
        chosenRegions() {
            return this.assigned_therapists.regions.reduce((total, current) => {
                return current.assigned ? [...total, current.id] : total
            }, []);
        },
        checkRegion(e) {
            const regions = this.chosenRegions();
            return e.regions.some((r) => regions.includes(r));
        },
        filterTherapist(therapists) {
            const regions = this.chosenRegions();
            return therapists
                .map((e) => {
                    if (!this.checkRegion(e)) e.assigned = false; // cancel therapist if he doesnt belong to chosen region
                    return e;
                })
                .filter((e) => regions.length !== 0 ? this.checkRegion(e) : true); // filter therapist whose region is not chosen
        },
        changeRegion() {
            this.filtered_therapists.therapists = {
                ...this.assigned_therapists.therapists,
                full_time: this.filterTherapist(this.assigned_therapists.therapists.full_time),
                part_time1: this.filterTherapist(this.assigned_therapists.therapists.part_time1),
                part_time2: this.filterTherapist(this.assigned_therapists.therapists.part_time2),
            }
        },
        changeInput(e) {
            this.assigned_therapists.therapists[e.key].forEach((elem) => {
                if (elem.id === e.therapist.id) elem.assigned = e.therapist.assigned
            });
            this.filtered_therapists.therapists[e.key].forEach((elem) => {
                if (elem.id === e.therapist.id) elem.assigned = e.therapist.assigned
            });
        },
        changeState(type, value) {
            const regions = this.chosenRegions();
            this.assigned_therapists.therapists[type].forEach((elem) =>  {
                if (elem.regions.some((r) => regions.includes(r)) || regions.length === 0) {
                    elem.assigned = value;
                }
            });

            this.filtered_therapists.therapists[type].forEach((elem) => {
                if (elem.regions.some((r) => regions.includes(r)) || regions.length === 0) {
                    elem.assigned = value;
                }
            });
        },
        searchTherapist(event) {
            for (let type in this.assigned_therapists.therapists) {
                this.filtered_therapists.therapists[type] = this.assigned_therapists.therapists[type].filter((e) => {
                    return (e.first_name.toLowerCase().includes(event.target.value.toLowerCase()) ||
                        e.last_name.toLowerCase().includes(event.target.value.toLowerCase())
                    )
                });
            }
        },
        typeName(name) {
            switch (name) {
                case 'full_time':
                    return "Full time";
                case 'part_time1':
                    return "Part time 1";
                case 'part_time2':
                    return "Part time 2";
            }
        },
        resetRegion() {
            this.assigned_therapists.regions.map(el => {
                el.assigned = false;
            })
        },
        resetTherapist() {
            this.show_in_region_full_time = false;
            this.show_in_region_part_time_one = false;
            this.show_in_region_part_time_two = false;

            for (let type in this.assigned_therapists.therapists) {
                this.assigned_therapists.therapists[type].forEach((e) => e.assigned = false);
            }
            for (let type in this.filtered_therapists.therapists) {
                this.filtered_therapists.therapists[type].forEach((e) => e.assigned = false);
            }
        },

        submitRepostOffer() {
            // TODO refactoring
            let regionsId = [];
            let therapistsId = [];

            this.assigned_therapists.regions.map(el => {
                if (el.assigned) {
                    regionsId.push(el.id)
                }
            });


            for (let type in this.assigned_therapists.therapists) {
                this.assigned_therapists.therapists[type].forEach((e) => {if(e.assigned) therapistsId.push(e.id)});
            }

            this.$newpetehealthapi.post(`/leads/${this.assigned_therapists.lead_id}/update_offer_presentability`,
                {
                    offer: {
                        show_out_region_full_time: this.assigned_therapists.show_out_region_full_time,
                        posted_at: moment(new Date()).utc().format('YYYY-MM-DD'),
                        status: "Offered",
                    },
                    therapist_ids: therapistsId,
                    region_ids: regionsId,
                }
            )
                .then(request => {
                    window.location.reload();
                    this.loginSuccessful(request)
                })
                .catch(() => this.loginFailed())
        }
    },
    watch: {
        show_in_region_full_time: function(v) {
            this.changeState('full_time', v);
        },
        show_in_region_part_time_one: function(v) {
            this.changeState('part_time1', v);
        },
        show_in_region_part_time_two: function(v) {
            this.changeState('part_time2', v);
        },
        async leadsIdEdit() {
            try {
                const res = await this.$newpetehealthapi.get(`/leads/${this.leadsIdEdit}/assigned_therapists`);
                if (res && res.data) {
                    this.assigned_therapists = res.data.assigned_therapists;
                    this.filtered_therapists = JSON.parse(JSON.stringify(res.data.assigned_therapists));
                    this.changeRegion();
                }
            } catch (e) {
                console.log('data', this.assigned_therapists)
            }
        }
    },
}
